import React, { useEffect, useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

import * as R from 'ramda';

import Container from '@components/Container';
import Loading from '@components/Base/Loading';

import { unLockScroll } from '@utils/ui';
import { fetch } from '@utils/fetch';

const useStyles = createUseStyles(({
  fontColor,
  rem,
}) => ({
  '@global': {
    button: {
      outline: 'transparent',
      margin: rem(6),
    },
  },
  root: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    color: '#FFF',
    display: 'flex',
    zIndex: 999,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  content: {
    marginTop: rem(10),
    height: '100%',
    '& > img': {
      width: '100%',
      height: '85%',
    }
  },
  title: {
    color: '#000',
    width: '100%',
    fontSize: rem(16),
    fontWeight: 'normal',
    lineHeight: '20px',
    marginTop: 50,
    '& > span': {
      width: '80%',
      textAlign: 'center',
      marginLeft: rem(30),
    }
  },
  close: {
    border: 'unset',
    color: fontColor.primary,
    cursor: 'pointer',
    padding: 0,
    outline: 'transparent',
    backgroundColor: 'transparent',
  },
  loading: {
    color: '#000',
    margin: [rem(200), 0],
  },
}), {
    name: 'CertificateModal'
});

// 证书弹窗
const CertificateModal = props => {
  const {
    t,
    currIdx,
    language,
    setCertificateOpen,
  } = props;
  const theme = useTheme();
  const classes = useStyles(theme);

  const [loading, setLoading] = useState(true);
  const [curr, setCurr] = useState(null);

  // 组合证书图片数据
  const combineData = (dataSource) => {
    const certList = [];
    const dcp1Data = R.pathOr([], ['dcp1'])(dataSource);
    const dcp2Data = R.pathOr([], ['dcp2'])(dataSource);
    const dcp3Data = R.pathOr([], ['dcp3'])(dataSource);
    const dcp4Data = R.pathOr([], ['dcp4'])(dataSource);
    const arr = [...dcp1Data, ...dcp2Data, ...dcp3Data, ...dcp4Data];
    arr.forEach(item => {
      const certlist = R.pathOr([], ['custom', 'certlist'])(item);
      certList.push(...certlist);
    })
    return certList;
  }

  useEffect(() => {
    setLoading(true);
    const params = {
      types: ['dcp1', 'dcp2', 'dcp3', 'dcp4'],
      language,
    };
    fetch(params).then(data => {
      const jsonData = R.pathOr({}, ['jsonData'])(data);
      const certList = combineData(jsonData);
      setCurr(certList[currIdx]);
      setLoading(false);
    }, err => {
      console.log(err, '获取图片信息失败，请重新打开');
    });
  }, [currIdx, language]);

  const handleClose = () => {
    setCertificateOpen(false);
    unLockScroll();
  }

  const createMain = () => {
    return (
      <>
        <Container
          flex
          alignItems='center'
          className={classNames(classes.title)}
        >
          <span>{t('certificate')} {currIdx + 1}</span>
          <button 
            onClick={handleClose}
            className={classNames(classes.close)} 
          >
            <Icon path={mdiClose} size='24px' />
          </button>
        </Container>

        <Container 
          flex 
          className={classNames(classes.content)}
        >
          <img 
            src={R.pathOr('', ['filelocation'])(curr)}
            alt='Certificate'
            width={320}
          />
        </Container>
      </>
    )
  }

  return (
    <Container
      flex
      direction='column'
      items='space-between'
      className={classNames(classes.root)}
    >
      {
        loading ? (<Loading size={1} className={classes.loading} />) : createMain()
      }
    </Container>
  )
};

CertificateModal.propTypes = {
  t: PropTypes.func.isRequired,
  currIdx: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
  setCertificateOpen: PropTypes.func.isRequired,
}

export default CertificateModal;
